import { type FC, memo, useState } from "react";
import { IconType } from "../../../../../common/components/icon/IconType";
import { IconClickable, IconClickableType } from "../../../../../common/components/icon/IconClickable";
import DeleteCartConfirmationModal from "~/domains/cart/components/DeleteCartConfirmationModal";

interface Props {
  onClick?: () => void;
  disabled?: boolean;
}

const ClearCartButton: FC<Props> = ({ onClick, disabled }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const cancel = () => setModalOpen(false);
  const confirm = () => {
    setModalOpen(false);
    onClick!();
  };
  const btnDisabled = disabled || !onClick;

  return (
    <>
      <IconClickable
        clickableType={IconClickableType.PRIMARY}
        onIconClick={openModal}
        disabled={btnDisabled}
        type={IconType.Bin}
        id={"cart_clearsection_btn"}
      />
      {modalOpen && (
        <DeleteCartConfirmationModal onCancel={cancel} onOk={confirm} messageKey={"deleteConfirmation.section"} />
      )}
    </>
  );
};

export default memo(ClearCartButton);
